import { useEffect, useRef, useState } from 'react';
import { Box, Tooltip } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { TransformedOperation } from '../helpers';

export const TextCell = ({
  value,
}: GridRenderCellParams<TransformedOperation, string>) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [fits, setFits] = useState(true);

  useEffect(() => {
    const checkIfTextFits = () => {
      const container = textRef.current;
      if (!container) return;

      // Checking if the content's width is greater than the container's width
      const contentFits = container.scrollWidth <= container.offsetWidth;
      setFits(contentFits);
    };

    checkIfTextFits();

    window.addEventListener('resize', checkIfTextFits);
    return () => window.removeEventListener('resize', checkIfTextFits);
  }, [value]);

  return (
    <Tooltip title={fits ? '' : value} placement="bottom">
      <Box
        ref={textRef}
        sx={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {value}
      </Box>
    </Tooltip>
  );
};
